import React from "react";
import { Link } from "react-router-dom";
import './footer.css'
const Footer = () => {
  const currentYear = new Date().getFullYear();

  // UI Theme Matrix (Matching Advanced Navbar)
  const colors = {
    bg: "#0f172a", // Deep sleek slate
    surface: "#1e293b", // Premium panel surface
    textMuted: "#94a3b8", // Muted platinum grey
    accent: "#3b82f6", // Electric tech blue
  };

  const styles = {
    footer: {
      background: colors.bg,
      borderTop: `1px solid ${colors.surface}`,
      padding: "20px 40px",
      color: colors.textMuted,
      fontFamily: "system-ui, -apple-system, sans-serif",
      fontSize: "13px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginTop: "auto", // Pushes footer to bottom if flex container is used
    },
    linksCluster: {
      display: "flex",
      gap: "20px",
    },
    link: {
      color: colors.textMuted,
      textDecoration: "none",
      cursor: "pointer",
      transition: "color 0.2s",
    },
    statusBadge: {
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      background: "#064e3b",
      color: "#34d399",
      padding: "4px 10px",
      borderRadius: "20px",
      fontSize: "11px",
      fontWeight: "600",
    },
  };

  return (
    <>
      <footer style={styles.footer}>
        <div>
          © {currentYear}{" "}
          <span style={{ color: "#fff", fontWeight: "500" }}>RBuyMart</span>.
        </div>

        {/* RIGHT: Quick System Utilities links */}
        <div style={styles.linksCluster}>
          <Link to="/terms">
            <span
              style={styles.link}
              onMouseOver={(e) => (e.target.style.color = "#fff")}
              onMouseOut={(e) => (e.target.style.color = colors.textMuted)}
            >
              Terms
            </span>
          </Link>
          <Link to="/terms">
            <span
              style={styles.link}
              onMouseOver={(e) => (e.target.style.color = "#fff")}
              onMouseOut={(e) => (e.target.style.color = colors.textMuted)}
            >
              Privacy
            </span>
          </Link>
        </div>
      </footer>
      <div class="footer-mobile">
        <ul class="menu-footer">
          <li>
            <Link to="/">
           <i class="material-icons">&#xe88a;</i>
              <span>Home</span>
            </Link>
          </li>
          <li>
            <Link to="/shop">
             <i class="material-icons">&#xe42a;</i>
              <span>Shop</span>
            </Link>
          </li>
          <li>
            <Link to="/cart"
              href="https://www.cost2costsupplement.com/cart"
             
            >
           <i class="material-icons">&#xe8cc;
                <span class="cart-counter">0</span>
              </i>
              <span>Cart</span>
            </Link>
          </li>
          <li>
            <Link to="/myorder">
          <i class="material-icons">&#xe8c9;</i>
              <span>My Order</span>
            </Link>
          </li>
          <li>
            <Link to=""
             
            >
            <i class="material-icons">&#xe5d2;</i>
              <span>Menu</span>
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Footer;
